import { memo } from 'react';

import CardInView from '@Components/CardInView';

import type { FC, ReactElement } from 'react';
import type { ProductData } from '@Types/Product';

export interface ProductItemProps {
  analyticsTitle: string;
  renderProduct: ReactElement;
  card: ProductData;
  index: number;
}

const ProductItem: FC<ProductItemProps> = (props) => {
  const { card, analyticsTitle, renderProduct, index } = props;

  return (
    <CardInView
      listTitle={analyticsTitle}
      card={card}
      position={index}
      cardType='product'
      id={card.id}
      preventHandleClick
    >
      {renderProduct}
    </CardInView>
  );
};

export default memo(ProductItem);
